export interface IStartDate {
  option: string;
  date: Date | string | undefined;
}

export class StartDate {
  public option: string;
  public date: Date | string | undefined;

  constructor(data: IStartDate) {
    this.option = data.option;
    this.date = data.date;
  }
}
